import { Box, Modal, Stack, Typography } from "@mui/material";
import { FunctionalModalStyle } from "../../../../../../common/constants/custom-style";
import LinearProgress, {
  LinearProgressProps,
} from "@mui/material/LinearProgress";
import GroupsIcon from "@mui/icons-material/Groups";
import { CustomerDatabaseStore } from "../../../../../../store/main/CustomerDatabaseStore";
interface Props {
  open: boolean;
  handleClose: Function;
  title: string;
}

const ProgressBarModal: React.FC<Props> = ({ open, handleClose, title }) => {
  const { progressCount, customerIds } = CustomerDatabaseStore();
  function LinearProgressWithLabel(
    props: LinearProgressProps & { value: number }
  ) {
    return (
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Box sx={{ mr: 1 }}>
          <GroupsIcon color="error" />
        </Box>
        <Box sx={{ width: "100%", mr: 1 }}>
          <LinearProgress
            variant="determinate"
            {...props}
            sx={{ height: "10px", borderRadius: "10px" }}
          />
        </Box>
        <Box sx={{ minWidth: 35 }}>
          <Typography variant="body2" color="text.secondary">{`${Math.round(
            props.value
          )}%`}</Typography>
        </Box>
      </Box>
    );
  }

  return (
    <>
      <Modal open={open}>
        <Box sx={FunctionalModalStyle}>
          <Stack spacing={2}>
            <Typography variant="h4" textAlign={"center"}>
              {`${title}ing Customers`}
            </Typography>
            <Typography variant="h6" fontWeight={500} textAlign={"center"}>
              {`${title} In Progress ${progressCount}/${customerIds.length}`}
            </Typography>
            <LinearProgressWithLabel
              value={(progressCount / customerIds.length) * 100}
            />
            <Typography variant="subtitle1" textAlign={"center"} color="error">
              Warning: Do not Close this Window!
            </Typography>
          </Stack>
        </Box>
      </Modal>
    </>
  );
};

export default ProgressBarModal;
